import type { ApproveOrderExecutorRequest, ScheduleOrderRequest } from '@/core/generated/api';
import type { OrderCommentActionFormValues } from './model/orderCommentActionSchema';

/** Собирает запрос утверждения исполнителя */
export const orderCommentToApproveRequest = (
    values: OrderCommentActionFormValues,
    orderId: string,
): ApproveOrderExecutorRequest => ({
    orderId: orderId.trim(),
    comment: values.comment.trim(),
});

/** Собирает запрос запуска поиска исполнителя */
export const orderCommentToScheduleRequest = (
    values: OrderCommentActionFormValues,
    orderId: string,
): ScheduleOrderRequest => ({
    orderId: orderId.trim(),
    comment: values.comment.trim(),
});
